import React from 'react';
import { Prospect } from 'types/common';
import { getProspectDetail } from 'api/prospect';
import { getGroupProspectDetail } from 'api/group';

const useProspectInfo = (id?: number, isPracticeView?: boolean): [Prospect | undefined, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [item, setItem] = React.useState<Prospect>();
    const fetchData = async () => {
        try {
            setLoading(true);
            const result = isPracticeView
                ? await getGroupProspectDetail(id!)
                : await getProspectDetail(id!);
            if (!result.error) {
                const data: Prospect = result.data?.data;
                if (data.insurances) {
                    data.insurances.sort((a, b) => {
                        if (!a.sort) {
                            return 1;
                        }
                        if (!b.sort) {
                            return -1;
                        }
                        return a.sort - b.sort;
                    });
                }
                setItem(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (!loading && id) {
            fetchData();
        }
    }, [id]);

    return [item, loading, fetchData];
};

export default useProspectInfo;
